import React, { useEffect } from "react";
import { Modal, Form, Input, Row, Col, Card, Switch } from "antd";
import { StatutService } from "../../services/StatutService";
import { catchError } from "../../services/DaoService";
import Toast from "../../helpers/Toast";
import PropTypes from "prop-types";
import CustomFormItem from "../utils/form/CustomFormItem";

const StatutEditForm = ({ visible, uid, onUpdate, onCancel }) => {
  const [form] = Form.useForm();
  const [editing, setEditing] = React.useState(false);
  const [validationErrors, setValidationErrors] = React.useState({});

  useEffect(() => {
    if (uid) {
      setEditing(true);
      StatutService.getInstance()
        .find(uid)
        .then((response) => {
          form.setFieldsValue(response.data);
        })
        .catch((error) => {
          catchError(error);
        })
        .finally(() => {
          setEditing(false);
        });
    }
  }, [uid, form]);

  const handleSave = () => {
    setEditing(true);
    form
      .validateFields()
      .then((values) => {
        StatutService.getInstance()
          .update(uid, values)
          .then((response) => {
            Toast.success(response.message);
            onUpdate(response.data);
          })
          .catch((error) => {
            const errors = error.response.data;
            if (errors.validation && Object.keys(errors?.errors).length) {
              setValidationErrors(errors.errors);
            } else {
              catchError(error);
            }
          })
          .finally(() => {
            setEditing(false);
          });
      })
      .catch(() => {
        setEditing(false);
      });
  };

  return (
    <Modal
      width={"50%"}
      open={visible}
      onCancel={onCancel}
      okText="Enregistrer"
      onOk={handleSave}
      title="Modifier statut"
      forceRender
    >
      <Card loading={editing} style={{ marginBottom: 20 }}>
        <Form
          layout="vertical"
          form={form}
          name="editStatutForm"
          initialValues={{
            enabled: 1,
          }}
        >
          <Row gutter={24}>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Nom"
                name="nom"
                rules={[{ required: true, message: "Veuillez saisir le nom!" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="text" />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Code"
                name="code"
                rules={[{ required: true, message: "Veuillez saisir le code!" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="text" />
              </CustomFormItem>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Statut"
                name="enabled"
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                valuePropName="checked"
              >
                <Switch checkedChildren="Actif" unCheckedChildren="Inactif" />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Couleur"
                name="couleur"
                rules={[{ required: true, message: "Veuillez sélectionner la couleur!" }]}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              >
                <Input type="color" />
              </CustomFormItem>
            </Col>
            <Col xs={24} md={24} lg={12}>
              <CustomFormItem
                label="Resolu"
                name="resolu"
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                valuePropName="checked"
              >
                <Switch checkedChildren="Résolu" unCheckedChildren="Non résolu" />
              </CustomFormItem>
            </Col>
          </Row>

        </Form>
      </Card>
    </Modal>
  );
};

export default StatutEditForm;

StatutEditForm.propTypes = {
  visible: PropTypes.bool,
  onUpdate: PropTypes.func,
  onCancel: PropTypes.func,
  uid: PropTypes.string.isRequired
};
